/**
 * TODO:
 *
 */
import C from "@/views/enterprise/rg-object-history/Constants";
import isString from "lodash/isString";
import isObject from "lodash/isObject";
import { WakeLineUtil } from "@/utils/index";
import * as turf from "@turf/turf";
import moment from "moment-timezone";
import { isValidUrl } from "@/utils/StringUtil";
import { RadarGridMixin } from "@/mixins";
const { createRgRiskLevelManager } = RadarGridMixin.methods;

export const isTracked = (objectKind) => {
  return isString(objectKind) && objectKind.length > 0;
};

export const addFrameIcons = (
  map, // Mapbox.Map instance
) => {
  if (!map.hasImage(getFrameIconId(C.RG_RISK_LEVEL.CAUTION))) {
    map.addImage(
      getFrameIconId(C.RG_RISK_LEVEL.CAUTION),
      getFrameIcon(C.RG_RISK_LEVEL.CAUTION),
      { pixelRatio: 2 },
    );
  }
  if (!map.hasImage(getFrameIconId(C.RG_RISK_LEVEL.DANGER))) {
    map.addImage(
      getFrameIconId(C.RG_RISK_LEVEL.DANGER),
      getFrameIcon(C.RG_RISK_LEVEL.DANGER),
      { pixelRatio: 2 },
    );
  }
  if (!map.hasImage(getFrameIconId(C.RG_RISK_LEVEL.SAFE))) {
    map.addImage(
      getFrameIconId(C.RG_RISK_LEVEL.SAFE),
      getFrameIcon(C.RG_RISK_LEVEL.SAFE),
      { pixelRatio: 2 },
    );
  }
};

export const getFrameIconId = (riskLevel, isKindValid = true) => {
  const riskLevelObject = C.RADAR_GRID_OBJECT_RISK_LEVEL[riskLevel];
  if (isKindValid) return riskLevelObject.frameIconId;
  return null;
};

export const getFrameIcon = (riskLevel) => {
  const size = 80;
  const riskLevelObject =
    C.RADAR_GRID_OBJECT_RISK_LEVEL[riskLevel] ||
    C.RADAR_GRID_OBJECT_RISK_LEVEL[C.RG_RISK_LEVEL.DANGER];
  return {
    width: size,
    height: size,
    data: new Uint8Array(size * size * 4),
    onAdd: function () {
      let canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;
      this.context = canvas.getContext("2d", { willReadFrequently: true });
    },

    render: function () {
      let ctx = this.context;

      ctx.clearRect(0, 0, this.width, this.height);
      ctx.beginPath();
      ctx.lineWidth = 5;
      ctx.lineJoin = "round";
      //左上
      ctx.moveTo(35, 10);
      ctx.lineTo(10, 10);
      ctx.lineTo(10, 35);
      //左下
      ctx.moveTo(10, 45);
      ctx.lineTo(10, 70);
      ctx.lineTo(35, 70);
      //右上
      ctx.moveTo(45, 10);
      ctx.lineTo(70, 10);
      ctx.lineTo(70, 35);
      //右下
      ctx.moveTo(45, 70);
      ctx.lineTo(70, 70);
      ctx.lineTo(70, 45);

      ctx.strokeStyle = riskLevelObject.blinkColor;
      ctx.stroke();

      this.data = ctx.getImageData(0, 0, this.width, this.height).data;

      return true;
    },
  };
};

export const isKindValid = (objectKind) => {
  return new Set(Object.values(C.RADAR_GRID_OBJECT_KIND)).has(objectKind);
};

export const createRgObjectProperty = (rgObject) => {
  /**
   * @typedef {Object} RiskLevelManagerResult
   * @property {string} objectIcon - The calculated object icon.
   * @property {string} frameIconId - The calculated frame icon ID.
   * @property {string} brinkIconId - The calculated brink icon ID.
   * @property {boolean} hasManualAssessment - manual or auto
   * @property {number} autoRiskLevel - The auto calculated risk level.
   * @property {number} riskLevel - The calculated risk level.
   */
  const rm = createRgRiskLevelManager(rgObject); // manual/autoを考慮してリスクレベルを計算
  const {
    objectIcon: icon,
    frameIconId: frameIcon,
    hasManualAssessment,
    autoRiskLevel,
    riskLevel: rmRiskLevel,
    isShip,
    isValidCog,
  } = rm;
  const riskLevel = C.RADAR_GRID_OBJECT_RISK_LEVEL[rmRiskLevel];
  return {
    id: rgObject.objectId,
    objectType: rgObject.objectType,
    trackNumber: rgObject.trackingNumber,
    textColor: riskLevel.color,
    heading: rgObject.cog,
    sog: rgObject.sog, // 速度 kn
    cog: rgObject.cog,
    k: rgObject.k,
    t: rgObject.t,
    icon, // 地図上のアイコン
    frameIcon, // 地図上のアイコンの枠
    hasManualAssessment,
    autoRiskLevel,
    riskLevel: rmRiskLevel,
    isShip,
    isValidCog,
    // lat: rgObject.lat, // TODO: 将来的にはlat, lonを使用する
    // log: rgObject.lon, // NOTE: ライブマップからの移植の名残りで、画面表示時にはlogとして保持する
    ...createRgObjectPictureProperty(rgObject),
  };
};

export const createRgObjectPictureProperty = (rgObject) => {
  if (!isObject(rgObject)) return {};
  if (!Array.isArray(rgObject.p)) return {};
  if (rgObject.p.length === 0) return {};
  const { p } = rgObject;
  return {
    targetIconOpacity: p[0].co ? 1 : 0,
    cameraId: p[0].ci,
    confidence: p[0].co ? `${Math.floor(p[0].co * 100)}` : "---",
    imgUrl: p[0].p,
    shootingDate: p[0].t ? toJST(p[0].t) : "---",
  };
};

export const toJST = (unix) => {
  let momentObjJst = moment(unix, "X").tz("Asia/Tokyo");
  return momentObjJst.format("YYYY/MM/DD/ HH:mm");
};

export const createTrackFeatures = (
  objectType,
  objectId,
  visible,
  points,
  idx,
  lastCoordinates,
  rgPlayBackObj,
) => {
  if (points.length <= 1) return [];

  const features = [];
  let prevCoordinates;
  let prevProps;
  for (let i = 0; i < idx; i++) {
    const prevPoint = points[i];
    const { cog, k, ai_r, man_r, sog, lat, lon, p, t } = prevPoint;
    const PointProps = createRgObjectProperty({
      ...rgPlayBackObj,
      cog,
      k,
      ai_r,
      man_r,
      sog,
      p,
      t,
    });
    const props = {
      objectType: objectType,
      objectId: objectId,
      visible: visible,
      color: WakeLineUtil.getVelocityColor(sog),
      opacity: 0.9,
      epoch: points[i].epoch || points[i].t,
      name: PointProps.trackNumber,
      lon,
      lat,
      speed: sog,
    };
    const currentCoordinates = [lon, lat];
    if (!prevCoordinates) {
      prevCoordinates = currentCoordinates;
      prevProps = props;
      continue;
    }

    features.push(
      turf.lineString([prevCoordinates, currentCoordinates], prevProps),
    );
    prevCoordinates = currentCoordinates;
    prevProps = props;
  }

  features.push(turf.lineString([prevCoordinates, lastCoordinates], prevProps));

  return features;
};

export const getValidSog = (sog) => {
  if (sog === C.INVALID_SOG) return null;
  return sog;
};

// 拡大表示するためのオブジェクトとして有効か判定するオブジェクトを作成
export const createExpandImgObject = (
  rgObject, //  {id: string, src: string, trackNumber: string, aiseaCameraName: string}]
) => {
  const { id, src, trackNumber, aiseaCameraName } = rgObject;
  const hasValidId = isString(id) && id !== "";
  const hasValidTrackNumber = isString(trackNumber) && trackNumber !== "";
  const hasValidAiseaCameraName =
    isString(aiseaCameraName) && aiseaCameraName !== "";
  const hasValidUrl = isValidUrl(src); // src はstringで画像のパスを指定

  return {
    value: rgObject, //  {id: string, src: string, trackNumber: string, aiseaCameraName: string}]
    hasValidId, // boolean
    hasValidTrackNumber, // boolean
    hasValidAiseaCameraName, // boolean
    hasValidUrl, // boolean
  };
};

// createExpandImgObjectの結果からエラーメッセージを取得
export const getErrorMessages = (
  { hasValidId, hasValidTrackNumber, hasValidAiseaCameraName, hasValidUrl }, // result of createExpandImgObject
) => {
  const idError = hasValidId ? "" : "Error Invalid id";
  const trackNumberError = hasValidTrackNumber
    ? ""
    : "Error Invalid trackNumber";
  const aiseaCameraNameError = hasValidAiseaCameraName
    ? ""
    : "Error Invalid src";
  const urlError = hasValidUrl ? "" : "Error Invalid aiseaCameraName";
  const errorMessages = {
    idError,
    trackNumberError,
    aiseaCameraNameError,
    urlError,
  };
  return errorMessages; // { idError: string; trackNumberError: string; aiseaCameraNameError: string; urlError: string; }
};
